import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { PAPER_SIZES } from "./couriers";

async function nodeToCanvas(node) {
  return html2canvas(node, { scale: 3, backgroundColor: "#ffffff", logging: false, useCORS: true });
}

// layout: "single" (one exact-size page per label) or "a4" (grid on A4)
export async function exportLabelsToPdf(nodes, sizeKey, layout = "single", filename = "label-thermal.pdf") {
  const { w, h } = PAPER_SIZES[sizeKey];
  if (!nodes.length) return;

  if (layout === "single") {
    const pdf = new jsPDF({ orientation: w > h ? "landscape" : "portrait", unit: "mm", format: [w, h] });
    for (let i = 0; i < nodes.length; i++) {
      const canvas = await nodeToCanvas(nodes[i]);
      const img = canvas.toDataURL("image/png");
      if (i > 0) pdf.addPage([w, h], w > h ? "landscape" : "portrait");
      pdf.addImage(img, "PNG", 0, 0, w, h);
    }
    pdf.save(filename);
    return;
  }

  // A4 grid
  const A4 = { w: 210, h: 297 };
  const margin = 8;
  const gap = 4;
  const cols = Math.max(1, Math.floor((A4.w - margin * 2 + gap) / (w + gap)));
  const rows = Math.max(1, Math.floor((A4.h - margin * 2 + gap) / (h + gap)));
  const perPage = cols * rows;
  const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  for (let i = 0; i < nodes.length; i++) {
    const posInPage = i % perPage;
    if (i > 0 && posInPage === 0) pdf.addPage("a4", "portrait");
    const col = posInPage % cols;
    const row = Math.floor(posInPage / cols);
    const x = margin + col * (w + gap);
    const y = margin + row * (h + gap);
    const canvas = await nodeToCanvas(nodes[i]);
    pdf.addImage(canvas.toDataURL("image/png"), "PNG", x, y, w, h);
  }
  pdf.save(filename);
}
